/* eslint-disable prefer-named-capture-group */
export const dependsOnModelRegex = '^([a-zA-Z0-9]*-[a-zA-Z0-9_]*)$';
export const dependsOnValuesRegex = '^([a-zA-Z0-9_]*)$';
export const onChangeFunctionRegex = /^[a-zA-Z0-9]*\([a-zA-Z0-9-_, ]*\)$/;


export const vatRates = [
  { value: '0', label: '0%' },
  { value: '5', label: '5%' },
  { value: '8', label: '8%' },
  { value: '23', label: '23%' },
  { value: 'np', label: 'np' },
  { value: 'zw', label: 'zw' },
  { value: 'vz', label: 'vz' }
];

export const invoiceTypes = [
  { value: 1, label: 'Faktura' },
  { value: 2, label: 'Faktura korygująca' },
  { value: 3, label: 'Faktura proforma' },
  { value: 4, label: 'Faktura do paragonu' },
  { value: 5, label: 'Paragon' },
  { value: 6, label: 'Paragon korygujący' }
];
